import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserpilotReloader } from '../../helper/userpilot-reloader.component';

export interface DialogData {
  name: string;
  saveClicked: boolean;
}

@Component({
  selector: 'dialog-table-name',
  templateUrl: './get-name.dialog.html',
  styleUrls: ['./get-name.dialog.scss']
})
export class GetNameDialogComponent extends UserpilotReloader {

  instruction = 'what name should the structure have?';

  trigger: string;

  constructor(
    public dialogRef: MatDialogRef<GetNameDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    super();
    if (data && data['instruction']) {
      this.instruction = data['instruction'];
    }
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onSaveClick() {
    this.data.saveClicked = true;
    this.dialogRef.close(this.data);
  }
}
